/**
 * Generate Module URL based on subdomain and environtment
 *
 * Menggunakan VITE_BASE_DOMAIN jika tersedia (diset per environment),
 * sehingga URL module selalu sesuai environment:
 *   - local:      rekyndness.test       → gate.rekyndness.test
 *   - staging:    v2.rekyndness.id      → gate.v2.rekyndness.id
 *   - production: rekyndness.id         → gate.rekyndness.id
 *
 * Fallback ke auto-detect hostname jika VITE_BASE_DOMAIN tidak diset.
 *
 * @param {string} subdomain - The subdomain of the module (e.g. 'gate', 'banksampah', 'org-name')
 * @param {string} path - The path to navigate to (optional)
 * @returns {string} The full URL
 */
export const getModuleUrl = (subdomain, path = '') => {
    if (typeof window === 'undefined') return '';

    const { protocol, hostname, port } = window.location;

    // Gunakan VITE_BASE_DOMAIN jika tersedia, fallback ke 2 bagian terakhir hostname
    const baseDomain = import.meta.env.VITE_BASE_DOMAIN || (() => {
        const parts = hostname.split('.');
        return parts.length === 1 ? parts[0] : parts.slice(-2).join('.');
    })();

    // Construct the base URL
    let baseUrl = subdomain
        ? `${protocol}//${subdomain}.${baseDomain}`
        : `${protocol}//${baseDomain}`;

    // Add port if it exists
    if (port) {
        baseUrl = `${baseUrl}:${port}`;
    }

    // Append path
    if (path) {
        const sanitizedPath = path.startsWith('/') ? path : `/${path}`;
        baseUrl = `${baseUrl}${sanitizedPath}`;
    }

    return baseUrl;
};
